import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { LOAD_API_BEGIN, logError, loadAPISuccess, loadAPICanceled } from "../actions";
import { loadAdapter } from "../utils/APIAdapter";
var defAdapter = "scorm12";
export default function loadAPI(action$, state$) {
    return action$.pipe(ofType(LOAD_API_BEGIN), mergeMap(function(action) {
        return !state$.value.api || state$.value.api && state$.value.api.id !== (action.api || defAdapter) ? from(loadAdapter(action.api || defAdapter)).pipe(switchMap(function(api) {
            return [
                loadAPISuccess({
                    api: api
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "load_api"
            }));
        })) : of(loadAPICanceled());
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "load_api"
        }));
    }));
}
